import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import PublicServiceConsents from '@di-shared/features/public-service/PublicServcieConsents';

export interface PublicServiceConsentsPageProps {
  vin: string;
}

function PublicServiceConsentsPage({vin}: PublicServiceConsentsPageProps) {
  const {t} = useInferableTranslation();

  return (
    <div className="wrap">
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T20352')}</h1>
      </Header>
      <PublicServiceConsents vin={vin} />
    </div>
  );
}

export default PublicServiceConsentsPage;
